import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { useThemeChange } from "../../../../utils/themeChange";
import { useApi } from "../../../../hooks/api/useApi";
import { ART } from "../../../../constants/api-constants";
import useAuthStore from "../../../../store/authStore";

import Button from "../../../../components/components/Button/Button";
import ExpandableImage from "../../../../components/components/ExpandableImage/ExpandableImage";

const { GET_ART_DETAIL } = ART;

const DetailArt = () => {
  const { art_id } = useParams();
  const { user } = useAuthStore((state) => ({ user: state.userLog }));
  const { getById } = useApi();
  const themeChange = useThemeChange();
  const navigate = useNavigate();

  const getArt = useQuery({
    queryKey: ["art", art_id],
    queryFn: () => getById(art_id, GET_ART_DETAIL),
  });

  return (
    <div className={themeChange.add("section")}>
      <section className="container">
        <div className="row mt-md-5 pt-md-4">
          {getArt.isLoading && <h5>Loading art detail.....</h5>}
          {getArt.isSuccess && (
            <>
              <div className="col-md-6 col-sm-12 text-center image-box">
                <ExpandableImage
                  url={getArt?.data?.previewImage}
                  imgClassName="img-property img-fluid img-rounded mb-sm-10"
                />
              </div>
              <div className="col-md-6 col-sm-12">
                <div className="item_info ">
                  <div className="row">
                    <div className="col-md-8 col-sm-12">
                      <h2>{getArt?.data?.name}</h2>
                    </div>
                    {user?.artist?.id === getArt?.data?.artistId && (
                      <div className="col-md-4 sm-12 d-flex action-buttons">
                        <Link
                          to={`/edit-license/${getArt?.data?.id}`}
                          state={{ defaultArt: getArt?.data }}
                          className="options"
                        >
                          <button id="btn_edit" title="Edit Text">
                            Edit
                          </button>
                        </Link>
                        {/* <button
                          id="btn_edit"
                          title="Delete NFT"
                            onClick={toggleDeleteNftModal()}
                        >
                          Delete
                        </button> */}
                      </div>
                    )}
                  </div>
                  <div>
                    <p style={{ textAlign: "justify" }}>
                      {getArt?.data?.description}
                    </p>
                  </div>
                  <div className="spacer-10"></div>
                  <div className="row">
                    {getArt?.data?.artist && (
                      <div className="col-lg-6 col-md-6 col-sm-12 mb-4">
                        <h5 style={{ marginBottom: "25px" }}>Artist</h5>
                        <Link
                          to={`/artists/${getArt?.data?.artistId}`}
                          style={{ textDecoration: "none" }}
                        >
                          <div className="item_author">
                            <div
                              className="author_list_pp"
                              style={{ height: "50px" }}
                            >
                              <span>
                                <img
                                  src={
                                    getArt?.data?.artist?.profileImage?.length
                                      ? getArt?.data?.artist?.profileImage
                                      : "/img/author/dummy_author.png"
                                  }
                                  alt=""
                                  className="lazy"
                                />
                              </span>
                            </div>
                            <div className="author_list_info">
                              <span style={{ fontWeight: "normal" }}>
                                {getArt?.data?.artist?.firstName.concat(
                                  " ",
                                  getArt?.data?.artist?.lastName
                                )}
                              </span>
                            </div>
                          </div>
                        </Link>
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <span className="spacer-20" />
                    <h5 style={{ marginBottom: "10px" }}>License Term</h5>
                    {getArt?.data?.licenseTerms.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </div>
                  <div className="row">
                    <span className="spacer-20" />
                    <h5 style={{ marginBottom: "10px" }}>License Territory</h5>
                    {getArt?.data?.licenseTerritory?.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </div>
                  <div className="row">
                    <span className="spacer-20" />
                    <h5 style={{ marginBottom: "10px" }}>License Available</h5>
                    <p>{getArt?.data?.licenseTypes}</p>
                  </div>
                  <div className="spacer-40"></div>
                  {!user && (
                    <Button
                      children="Inquire"
                      onClick={() =>
                        navigate("/call-to-action", {
                          state: {
                            artDetail: getArt?.data,
                          },
                        })
                      }
                    />
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default DetailArt;
